export default "__VITE_ASSET__3yKTmV5M__"